import { Outlet } from "react-router-dom";

function RefundsMain(){
    return(
        <div className='h-full w-full'>
            <Outlet/>
        </div>
    )
}

export default RefundsMain;